import { CHANGE_STATUS_SOCKET, SET_SOCKET, CHANGE_ID, RECONNECT, DISCONNECT } from "./type";

export const changeStatusSocket = status => async dispatch => {
  dispatch({
    type: CHANGE_STATUS_SOCKET,
    payload: status,
  });
};

export const setSocket = socket => async dispatch => {
  dispatch({
    type: SET_SOCKET,
    payload: socket,
  });
};

export const changeIdLogout = id => async dispatch => {
  dispatch({
    type: CHANGE_ID,
    payload: id,
  });
};

export const disconnectSocket = status => async dispatch => {
  dispatch({
    type: DISCONNECT,
    payload: status,
  });
};

export const reconnectSocket = status => async dispatch => {
  dispatch({
    type: RECONNECT,
    payload: status,
  });
};